<div class="filter-container">
  <div class="padding-margin">
    <div class="width-180px">
      <custom-year-picker
        styleType="rounded"
        (yearSelected)="handleYearFilterValueChange($event)"
      ></custom-year-picker>
    </div>
  </div>
  <div class="padding-margin">
    <app-contract-seller-selector
      *ngIf="!isLoadingItems; else spinner"
      [sellerList]="sellerList"
      widthClass="width-400px"
      (sellerChanged)="handleSellerValueChange($event)"
    ></app-contract-seller-selector>
  </div>
  <div class="padding-margin">
    <app-contract-seller-selector
      #sellerToTransferSelector
      *ngIf="!isLoadingItems; else spinner"
      [sellerList]="sellerToTransferList"
      widthClass="width-400px"
      [selectedSellerPlaceholder]="'Transferer '
       + ((transferContracts?.length > 0) ?
        (transferContracts.length + ' contrat(s) à ') : 'à ')"
      (sellerChanged)="handleContractTransferValueChange($event)"
    ></app-contract-seller-selector>
  </div>
  <div class="padding-margin">
    <button
      class="tv-ns-primary-large-button-on-dark-bg"
      [disabled]="transferSellerActionDisable || !(transferContracts?.length)"
      (click)="transferContractsToSeller()">
      <div *ngIf="isLoadingItems" class="spinner-container">
        <mat-spinner diameter="15" class="light-spinner"></mat-spinner>
      </div>
      Transférer
    </button>
  </div>
  <ng-template #spinner>
    <div class="spinner-container width-100">
      <mat-spinner diameter="25" class="light-spinner"></mat-spinner>
    </div>
  </ng-template>
</div>
